import React from "react";
import { Wind, Activity, CloudFog } from "lucide-react";

function Meter({ label, value, color, testId, Icon }) {
  const segments = 20;
  const filled = Math.round((value / 100) * segments);
  const low = value <= 30;
  return (
    <div data-testid={testId} style={{ minWidth: 190 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 5 }}>
        <Icon size={13} color={color} />
        <span
          style={{
            fontSize: 10,
            letterSpacing: "0.2em",
            textTransform: "uppercase",
            color: low ? "#e2743a" : "#9aa0ac",
          }}
        >
          {label}
        </span>
        <span
          className="font-mono-tel"
          style={{ marginLeft: "auto", fontSize: 11, color: low ? "#e2743a" : color }}
        >
          {Math.round(value)}
        </span>
      </div>
      <div style={{ display: "flex", gap: 2 }}>
        {new Array(segments).fill(0).map((_, i) => (
          <span
            key={i}
            style={{
              flex: 1,
              height: 8,
              borderRadius: 1,
              background: i < filled ? color : "rgba(255,255,255,0.08)",
              boxShadow: i < filled ? `0 0 6px ${color}88` : "none",
              transition: "background 0.2s ease",
              opacity: i < filled ? (low ? 0.85 : 1) : 1,
            }}
          />
        ))}
      </div>
    </div>
  );
}

// One attached panel — Smoke (top) → Breath → Stamina, so they read as a single group.
export default function VitalityMeters({ breath, stamina, smoke, onSmoke }) {
  const showSmoke = typeof smoke === "number";
  return (
    <div className="hud-panel" style={{ padding: "12px 18px", borderRadius: 4, display: "grid", gap: 11, minWidth: 190 }}>
      {showSmoke && (
        <div data-testid="smoke-density-dial">
          <div style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 5 }}>
            <CloudFog size={13} color="#c9a24b" />
            <span style={{ fontSize: 10, letterSpacing: "0.2em", textTransform: "uppercase", color: "#c9a24b" }}>Smoke</span>
            <span className="font-mono-tel" style={{ marginLeft: "auto", fontSize: 11, color: "#e9e4d8" }}>{Math.round(smoke * 100)}%</span>
          </div>
          <input
            data-testid="smoke-density-slider"
            type="range" min={0} max={100} value={Math.round(smoke * 100)}
            onChange={(e) => onSmoke(Number(e.target.value) / 100)}
            style={{ width: "100%", accentColor: "#c9a24b", cursor: "pointer", display: "block" }}
          />
        </div>
      )}
      {showSmoke && <div style={{ height: 1, background: "rgba(201,162,75,0.18)" }} />}
      <Meter label="Breath" value={breath} color="#62a8e5" testId="hud-breath-meter" Icon={Wind} />
      <Meter label="Stamina" value={stamina} color="#4cd07a" testId="hud-stamina-meter" Icon={Activity} />
    </div>
  );
}
